import React from 'react';
import classNames from 'classnames';
import { FDBodyText } from '@facet-wealth/design';
import { inputDefaultProps, inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import { useDataAttrs } from 'Helpers/Testing';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ThrowInDev from 'Helpers/ThrowInDev';

const useStyles = buildUseStyles('Richtext', (() => ({
  root: {
    '& ul, & ol': {
      paddingInlineStart: '0.75rem',
    },
  },
  rootUnspaced: {
    '& > *:first-child': {
      marginTop: 0,
    },
    '& > *:last-child': {
      marginBottom: 0,
    },
  },
  inheritColor: {
    '& *, & a': {
      color: 'inherit',
    },
  },
  underlineLink: {
    '& a': {
      textDecoration: 'underline',
    },
  },
})));

export const Richtext = (props) => {
  const {
    Component,
    align,
    color,
    size,
    value,
    richtext,
    unspaced,
    inheritColor,
    underlineLink,
    ...rest
  } = props;

  const classes = useStyles();
  const dataAttrs = useDataAttrs(rest);

  if (!richtext) {
    return <ThrowInDev err={"You're trying to use the Richtext component with a non-richtext field - don't. Maybe you're missing hint=richtext, but think carefully about security before adding it."} fallback={<Component align={align} color={color} size={size} value={value} />} />;
  }

  return (
    <Component
      {...dataAttrs}
      align={align}
      color={color}
      size={size}
      value={(
        <div
          className={classNames(classes.root, { [classes.rootUnspaced]: unspaced }, { [classes.inheritColor]: inheritColor }, { [classes.underlineLink]: underlineLink })}
          dangerouslySetInnerHTML={{ __html: value }} // eslint-disable-line react/no-danger
        />
      )}
    />
  );
};

Richtext.defaultProps = {
  Component: FDBodyText,
  align: inputDefaultProps.align,
  color: undefined,
  size: 'md',
  unspaced: false,
};

Richtext.propTypes = {
  Component: PropTypes.element,
  align: inputPropTypes.align,
  color: inputPropTypes.textColor,
  size: inputPropTypes.textSize,
  value: inputPropTypes.value.isRequired,
  unspaced: PropTypes.bool,
  // MetaControl/Types/String.jsx will pass this prop set to true if hint=richtext is on the model
  richtext: PropTypes.oneOf([true]).isRequired,
};
